import { useCallback, type ReactNode } from 'react'
import { openLink } from '@/helpers'

interface ExternalLinkProps {
  href: string
  children: ReactNode
  useDefaultBrowser?: boolean
}

const ExternalLink = ({
  href,
  children,
  useDefaultBrowser = false,
}: ExternalLinkProps) => {
  const handleClick = useCallback((e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault()
    openLink(href, useDefaultBrowser)
  }, [href, useDefaultBrowser])

  return (
    <a
      href={href}
      target='_blank'
      rel='noreferrer'
      onClick={handleClick}
    >
      {children}
    </a>
  )
}

export default ExternalLink
